import { render, staticRenderFns } from "./menubar.html?vue&type=template&id=3bb0520e&scoped=true&"
import script from "./menubar.js?vue&type=script&lang=js&"
export * from "./menubar.js?vue&type=script&lang=js&"
import style0 from "./menubar.css?vue&type=style&index=0&id=3bb0520e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0520e",
  null
  
)

export default component.exports